import { Paper } from '@mantine/core';
import React, { ReactNode } from 'react';

interface Props {
  children?: React.ReactNode | string;
}
function XPaper(props: Props) {
  const { children } = props;

  return (
    <>
      <Paper
        withBorder
        radius='md'
        shadow='lg'
        style={{
          flex: 1,
          height: '100%',
          padding: '20px 0',
          overflow: 'auto',
        }}
      >
        {children}
      </Paper>
    </>
  );
}

export default XPaper;
